module.exports = __webpack_public_path__ + "static/img/advertising_phone@2x.c264a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adv/advertising_phone@2x.png
// module id = 7lko
// module chunks = 1